import produce from 'immer'

import * as ACTs from './actions'

export const Types = {}

Object.values(ACTs).forEach((fn) => {
  const type = fn().type

  Types[type.split('/').pop()] = type
})

const INITIAL_STATE = {
  loadings: {
    resetDate: false
  },
  errors: {
    resetDate: false
  },
  resetDate: ''
}

export default function resetDateReducers(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case Types.SET_RESET_DATE: {
        draft.loadings.resetDate = true
        draft.errors.resetDate = false
        break
      }
      case Types.UPDATE_RESET_DATE: {
        draft.loadings.resetDate = false
        draft.errors.resetDate = action.payload?.error || false
        draft.resetDate = action.payload?.email || false
        break
      }
      case Types.CLEAR_RESET_DATE: {
        draft.loadings.resetDate = false
        draft.errors.resetDate = false
        draft.resetDate = ''
        break
      }
      default:
    }
  })
}
